import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import type { QueryApiOptions, OptionalQueryOptions } from '../../types/types';
import {
  EnrichedProductParams,
  ProductFeaturesComparisonPathVariables,
  ProductFeaturesComparisonResponse,
} from '@as-react/common-types';
import { getInformation, getComparisonFeatures } from './product.api';

export const productQueryKeys = {
  all: () => ['product'] as QueryKey,
  information: ({ productCode, colorId }: EnrichedProductParams) =>
    [...productQueryKeys.all(), 'information', productCode, colorId] as QueryKey,
  comparisonFeatures: (productId: number) => [...productQueryKeys.all(), 'comparisonFeatures', productId] as QueryKey,
};

export const productQueries = (apiOptions: QueryApiOptions) => ({
  getInformation: (params: EnrichedProductParams) => ({
    queryKey: productQueryKeys.information(params),
    queryFn: () => getInformation(apiOptions, params),
  }),
  getComparisonFeatures: (
    params: ProductFeaturesComparisonPathVariables,
    options: OptionalQueryOptions<ProductFeaturesComparisonResponse> = {}
  ) =>
    ({
      ...options,
      queryKey: productQueryKeys.comparisonFeatures(params.productId),
      queryFn: () => getComparisonFeatures(apiOptions, params),
    }) as UseQueryOptions<ProductFeaturesComparisonResponse, Error, ProductFeaturesComparisonResponse>,
});
